import axios from 'axios';

export default {
    GET_NEW_NOTIFICATION_STATUS(){
        return axios.get(`notification/new/`)
    },
    GET_ALL_NOTIFICATIONS(queries) {
        let queryString = new URLSearchParams(queries).toString()
        return axios.get(`/api/notification/?${queryString}`)
    },
    GET_NOTIFICATION_SETTINGS(organisationId) {
        return axios.get(`/api/notification/${organisationId}/setting/`)
    },
    UPDATE_NOTIFICATION_SETTINGS(organisationId , newSettings) {
        return axios.patch(`/api/notification/${organisationId}/setting/`, newSettings)
    },
    MARK_ALL_READ(){
        return axios.patch(`notification/mark_read/`)
    },
    MARK_INDIVIDUAL_READ(id,queryParams){
        return queryParams? axios.patch(`/api/notification/${id}/mark_read/?${queryParams}`) : axios.patch(`/api/notification/${id}/mark_read/`)
    }
}